import React from 'react'
import { massCheck, copyAttempt } from '../timesheetUtils'
import { baseUrl } from '../../assets/Animations'
import axios from 'axios'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const InvoicesTab = ({schoolList, invoices, setInvoices, schoolTab, teachers, setOpenInvoice}) => {

    const turnTeacherIDintoTeacherName = (id, teachers) => {
        for(let i = 0; i < teachers.length; i++) {
            if(teachers[i].TeacherID === id) {
                return teachers[i].Name
            }
        }
        //teachers.find((teach) => teach.TeacherID === id).Name 
    }

    const badFunctionToRemoveDuplicates = (listOfTeachers) => {
        let seen = {}
        let arrayOfT = []
        for(let i = 0; i < listOfTeachers.length; i++) {
            if(seen[listOfTeachers[i].teachersId]) {

            } else {
                arrayOfT.push(listOfTeachers[i])
                seen[listOfTeachers[i].teachersId] = true
            }

        }
        return arrayOfT
    }

    const openTheInvoiceAndGetFamilyInfo = (invoice, shouldItDelete) => {
        let invoiceWithFamilyInfo = invoice
        if(shouldItDelete) {
            axios.delete(`${baseUrl}/invoice/${invoice.invoiceId}`)
            .then((res) => setInvoices(invoices.filter(item => item.invoiceId !== res.data.invoiceId)))
            .catch((err) => console.log(err))
        } else {
            axios.get(`${baseUrl}/family-lookup/${invoice.waveCustomerId}`, myHeader)
            .then((res) => {
                invoiceWithFamilyInfo.familyInfo = res.data
                setOpenInvoice(invoiceWithFamilyInfo)
            })
            .catch((err) => {
                console.log(err)
            })
        }
    }

    const againFindStudentRate = (theLesson, theInvoice, nameOnInvoice, lengthOfLesson) => {
        let found = false
        if(parseInt(lengthOfLesson) === 31 || parseInt(lengthOfLesson) === 46 || parseInt(lengthOfLesson) === 61) {
          found = true
          if(parseInt(lengthOfLesson) === 31) {
            return 25
          } else if (parseInt(lengthOfLesson) === 46) {
            return 35
          } else if (parseInt(lengthOfLesson) === 61) {
            return 45
          }
        } else {
            if(theLesson.studentAllRates) {
                return theLesson.studentAllRates[parseInt(lengthOfLesson)]
            } else {
                //-----------THIS IS GOING OFF OF WHAT THE STUDENTS RATE WAS BASED OFF OF REAL TIME DATABASE RATE
                if(theInvoice.familyInfo) {
                    for(let i = 0; i < theInvoice.familyInfo.students.length; i++) {
                        if(theInvoice.familyInfo.students[i].studentName === nameOnInvoice) {
                            found = true
                            if(!theInvoice.familyInfo.students[i].allRates) {
                              return theInvoice.familyInfo.students[i].lessonRate
                            } else {
                              return theInvoice.familyInfo.students[i].allRates[lengthOfLesson]
                            }
                        }
                    }
                }
            }
        }
        if(!found) {
            //alert('Student does not exist in the database. Either change student name or go to Student Database and add student to family.')
            return 0
        }  
    }

    const estimateCharge = (theInvoice) => {
        let total = 0
        for(let i = 0; i < theInvoice.lessonsToBeBilled.length; i++) {
            total = Math.floor(parseInt(total) + parseInt(againFindStudentRate(theInvoice.lessonsToBeBilled[i], theInvoice, theInvoice.lessonsToBeBilled[i].studentName, theInvoice.lessonsToBeBilled[i].lessonLength)))
        }
        for(let i = 0; i < theInvoice.extrasToBeBilled.length; i++) {
          total = Math.floor(parseInt(total) + parseInt(theInvoice.extrasToBeBilled[i].amount))
        }
        return total
    }

    return(
        <div>
        {schoolList.map((school) => (
        <div className="whole-invoice-wrapper" key={school}>
            {school === schoolTab &&
                <div key={school}>
                    <div className="timesheet-school-name__title">
                        <div className="student-db-btn-wrapper">
                            <div className="add-email-btn on-timesheet" onClick={() => copyAttempt()}>Copy Emails</div>
                        </div>
                    </div>
                    <table className="student-table">
                        <thead>
                            <tr>
                                <th><input onClick={(e) => massCheck(e.target.checked)} style={{border: '1px solid black'}} type="checkbox" /></th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Invoice Status</th>
                                <th>Total</th>
                                <th>Teachers</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.map(invoice => (
                                invoice.school === school &&
                                <tr key={invoice.invoiceId} className="each-row">
                                    <td><input className={"student-checkbox"} type="checkbox" style={{border: '1px solid black'}} value={invoice.email}/></td>
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >{invoice.familyName}</td>
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >{invoice.email}</td>
                                    {
                                        (() => {
                                            switch(invoice.status) {
                                                case 'In Wave':
                                                    return <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)}><p className="status-in-wave">{invoice.status}</p></td>
                                                case 'Scholarship':
                                                    return <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)}><p className="status-scholarship">{invoice.status}</p></td>
                                                default:
                                                    return <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)}><p className="status-submitted">{invoice.status}</p></td>
                                            }
                                        })()
                                    }
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >${estimateCharge(invoice)}</td>
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >{badFunctionToRemoveDuplicates(invoice.teachers).map(teacher => <div key={teacher.teachersId}>{teacher.submittedTimesheet ? <p>{turnTeacherIDintoTeacherName(teacher.teachersId, teachers)}</p> : <p style={{color: "red"}}>{turnTeacherIDintoTeacherName(teacher.teachersId, teachers)}</p>}</div>)}</td>
                                    <td className="delete-this-invoice" onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, true)}>Delete</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    ))}
</div>  
    )
}
export default InvoicesTab